<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="csSpecialApplications">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editPage.open(0)">
            新建
          </el-button>
          <!--          <el-button v-if="delAuth" type="danger" @click="deleteRows">批量删除</el-button>-->
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="申请编号">
              <el-input v-model.trim="filter.billNo" clearable/>
            </vm-search>
            <vm-search label="客户名称">
              <el-input v-model.trim="filter.customerName" clearable/>
            </vm-search>
            <vm-search label="售后单号">
              <el-input v-model.trim="filter.afterSaleNo" clearable/>
            </vm-search>
            <vm-search label="出厂编号">
              <el-input v-model.trim="filter.factorNo" clearable/>
            </vm-search>
            <vm-search label="客户单号">
              <el-input v-model.trim="filter.customerBillNo" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="billNo" width="160" align="center" label="申请编号">
          <template slot-scope="scope">
            <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</span>
            <el-button
                v-clipboard="scope.row.billNo"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                round
                icon="el-icon-chat-line-square"/>
          </template>
        </el-table-column>
        <el-table-column prop="title" align="center" label="申请标题"/>
        <el-table-column prop="afterSaleNo" align="center" label="售后单号"/>
        <el-table-column prop="urgency" align="center" label="紧急程度">
          <template slot-scope="scope">
            {{constant.urgencyType[scope.row.urgency]}}
          </template>
        </el-table-column>
        <el-table-column prop="cause" align="center" label="特批原因">
          <template slot-scope="scope">
            {{constant.specialApplicationCause[scope.row.cause]}}
          </template>
        </el-table-column>
        <el-table-column prop="customerName" align="center" label="客户名称"/>
        <el-table-column prop="nodeDesc" width="140" align="center" label="当前节点">
          <template slot-scope="scope">
            {{scope.row.nodeDesc}}
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button
                v-if="scope.row.status===0"
                type="primary"
                @click="$refs.editPage.open(scope.row.pkid)">
              编辑
            </el-button>
            <el-button v-if="scope.row.creatorId === currentId" type="danger" :disabled="scope.row.status!==0" @click="deleteRow(scope.row)">删除</el-button>
            <el-button
                v-if="scope.row.status===0"
                type="success"
                @click="submit(scope.row.pkid)">
              提交
            </el-button>
          </template>
        </el-table-column>
      </vm-table>
      <cs-special-application-edit ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  import CsSpecialApplicationEdit from "@/views/afterSalesManagement/CsSpecialApplication/CsSpecialApplicationEdit";

  export default {
    name: "",
    components: {CsSpecialApplicationEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        currentId: loginUtil.getUserId(),
        ids: [],
        filter: {
          billNo: "",
          customerName: "",
          factorNo: "",
          afterSaleNo: "",
          customerBillNo: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", "csSpecialApplications/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      select(selection) {
        this.ids = [];
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      deleteRow(row) {
        this.ids = [];
        this.ids.push(row.pkid);
        this.deleteRows();
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      goto(row) {
        this.$router.push({
          path: "/CsSpecialApplication",
          query: {
            billType: 32,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
      deleteRows() {
        if (this.ids.length === 0) {
          this.$message.error("请先选择删除项");
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "csSpecialApplications", this.ids)
            .then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        });
      },
    },
  };
</script>
<style scoped>
</style>
